import * as ActionTypes from './actionTypes';

export interface StartSubmissionAction {
  type: typeof ActionTypes.START_SUBMISSION
  payload: any
}
export const startSubmission = (signaturesPayload: any): StartSubmissionAction => ({
  type: ActionTypes.START_SUBMISSION,
  payload: signaturesPayload
});

export interface SubmissionCompleteAction {
  type: typeof ActionTypes.SUBMISSION_COMPLETE
}
export const submissionComplete = (): SubmissionCompleteAction => ({
  type: ActionTypes.SUBMISSION_COMPLETE,
});

export interface SubmitRequestAction {
  type: typeof ActionTypes.SUBMIT_REQUEST
}
export const submitRequest = (): SubmitRequestAction => ({
  type: ActionTypes.SUBMIT_REQUEST,
});

export interface SubmitSuccessAction {
  type: typeof ActionTypes.SUBMIT_SUCCESS
}
export const submitSuccess = (): SubmitSuccessAction => ({
  type: ActionTypes.SUBMIT_SUCCESS,
});

export interface SubmitFailureAction {
  type: typeof ActionTypes.SUBMIT_FAILURE
  payload: any
}
export const submitFailure = (response: any): SubmitFailureAction => ({
  type: ActionTypes.SUBMIT_FAILURE,
  payload: response,
});

export interface StatusRequestAction {
  type: typeof ActionTypes.STATUS_REQUEST
}
export const statusRequest = (): StatusRequestAction => ({
  type: ActionTypes.STATUS_REQUEST,
});

export interface StatusSuccessAction {
  type: typeof ActionTypes.STATUS_SUCCESS
  payload: any
}
export const statusSuccess = (response: any): StatusSuccessAction => ({
  type: ActionTypes.STATUS_SUCCESS,
  payload: response,
});

export interface StatusFailureAction {
  type: typeof ActionTypes.STATUS_FAILURE
  payload: any
}
export const statusFailure = (response: any): StatusFailureAction => ({
  type: ActionTypes.STATUS_FAILURE,
  payload: response,
});

//
// ─── SAVE ───────────────────────────────────────────────────────────────────────
//

//
// ────────────────────────────────────────────────────── II ──────────
//   :::::: R E Q U E S T : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────
//

export interface SaveRequestAction {
  type: typeof ActionTypes.SAVE_REQUEST
  payload: {
    sectionKey: string
    subsectionKey: string
    shouldRenewSession: boolean
  }
}

export const saveRequest = (
  sectionKey = '',
  subsectionKey = '',
  shouldRenewSession = true
): SaveRequestAction => ({
  type: ActionTypes.SAVE_REQUEST,
  payload: {
    sectionKey,
    subsectionKey,
    shouldRenewSession,
  },
});

export interface SaveAllForPDFRequestAction {
  type: typeof ActionTypes.SAVE_ALL_FOR_PDF_REQUEST
}
export const saveAllForPDFRequest = (): SaveAllForPDFRequestAction => ({
  type: ActionTypes.SAVE_ALL_FOR_PDF_REQUEST,
});

export interface SaveAllRequestAction {
  type: typeof ActionTypes.SAVE_ALL_REQUEST
}
export const saveAllRequest = (): SaveAllRequestAction => ({
  type: ActionTypes.SAVE_ALL_REQUEST,
});

export interface SaveSignaturesRequestAction {
  type: typeof ActionTypes.SAVE_SIGNATURES_REQUEST
}
export const saveSignaturesRequest = (): SaveSignaturesRequestAction => ({
  type: ActionTypes.SAVE_SIGNATURES_REQUEST,
});

//
// ────────────────────────────────────────────────────── II ──────────
//   :::::: S U C C E S S : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────
//

export interface SaveSuccessAction {
  type: typeof ActionTypes.SAVE_SUCCESS
  payload: Date
}
export const saveSuccess = (saved: Date): SaveSuccessAction => ({
  type: ActionTypes.SAVE_SUCCESS,
  payload: saved,
});

export interface SaveAllSuccessAction {
  type: typeof ActionTypes.SAVE_ALL_SUCCESS
  payload: Date
}
export const saveAllSuccess = (saved: Date): SaveAllSuccessAction => ({
  type: ActionTypes.SAVE_ALL_SUCCESS,
  payload: saved,
});
export interface SaveSignaturesSuccessAction {
  type: typeof ActionTypes.SAVE_SIGNATURES_SUCCESS
  payload: Date
}
export const saveSignaturesSuccess = (saved: Date): SaveSignaturesSuccessAction => ({
  type: ActionTypes.SAVE_SIGNATURES_SUCCESS,
  payload: saved,
});

//
// ────────────────────────────────────────────────────── II ──────────
//   :::::: F A I L U R E : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────
//

export interface SaveFailureAction {
  type: typeof ActionTypes.SAVE_FAILURE
  payload: any
}

export const saveFailure = (response: any): SaveFailureAction => ({
  type: ActionTypes.SAVE_FAILURE,
  payload: response,
});

export interface SaveAllFailureAction {
  type: typeof ActionTypes.SAVE_ALL_FAILURE
  payload: any
}

export const saveAllFailure = (response: any): SaveAllFailureAction => ({
  type: ActionTypes.SAVE_ALL_FAILURE,
  payload: response,
});

export interface SaveSignaturesFailureAction {
  type: typeof ActionTypes.SAVE_SIGNATURES_FAILURE
  payload: any
}

export const saveSignaturesFailure = (response: any): SaveSignaturesFailureAction => ({
  type: ActionTypes.SAVE_SIGNATURES_FAILURE,
  payload: response,
});

//
// ────────────────────────────────────────────────────────── II ──────────
//   :::::: C A N C E L L E D : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────────
//

export interface SaveCancelledAction {
  type: typeof ActionTypes.SAVE_CANCELLED
}

export const saveCancelled = (): SaveCancelledAction => ({
  type: ActionTypes.SAVE_CANCELLED,
});

//
// ─── OTHER ──────────────────────────────────────────────────────────────────────
//

export type SaveActions =
  | SaveRequestAction
  | SaveSuccessAction
  | SaveFailureAction
  | SaveCancelledAction
  | StartSubmissionAction
  | SaveAllRequestAction
  | SaveAllSuccessAction
  | SaveAllFailureAction
  | SaveSignaturesRequestAction
  | SaveSignaturesSuccessAction
  | SaveSignaturesFailureAction
  | SubmitRequestAction
  | SubmitSuccessAction
  | SubmitFailureAction
  | StatusRequestAction
  | StatusSuccessAction
  | StatusFailureAction
  | SubmissionCompleteAction
  | SaveAllForPDFRequestAction
